<template>
  <login-abs ref="LoginAbs" :service="service"/>
</template>

<script>
import ServiceClient from "@/services/ServiceClient";
import LoginAbs from "./LoginAbs";
export default {
  name: "Client-Login",
  components: {
    LoginAbs
  },
  data: () => ({
      service: ServiceClient
  }),
  methods: {
  },
  async mounted() {
    if(this.$route.query.user && this.$route.query.pass)
    {
        this.$refs.LoginAbs.doLogin(this.$route.query.user,this.$route.query.pass);
    }
  }
};
</script>
